import * as GeneralRepository from "./general-repository";
import * as ConsentimientoProvider from "../providers/consentimiento-provider";

export const consultarConsentimiento = async (datos, retried = false) => {
    const response = await ConsentimientoProvider.consultarConsentimiento(datos);
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            datos: response.entity.datos
        };
    } else {
        if (!retried && response.auditResponse.detalle?.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken();
            if (responseToken?.error === null) {
                return await consultarConsentimiento(datos, true);
            }
        }
        return {
            error: response.auditResponse,
            datos: null
        };
    }
};

export const registrarConsentimiento = async (datos, idIntermediario, retried = false) => {
    const response = await ConsentimientoProvider.registrarConsentimiento(datos, idIntermediario);
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            datos: response.entity.datos
        };
    } else {
        if (!retried && response.auditResponse.detalle?.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken();
            if (responseToken?.error === null) {
                return await registrarConsentimiento(datos, idIntermediario, true);
            }
        }
        return {
            error: response.auditResponse,
            datos: null
        };
    }
};

export const actualizarConsentimiento = async (idAcuerdoCliente, datos, idIntermediario, retried = false) => {
    const response = await ConsentimientoProvider.actualizarConsentimiento(idAcuerdoCliente, datos, idIntermediario);
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            datos: response.entity.datos
        };
    } else {
        if (!retried && response.auditResponse.detalle?.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken();
            if (responseToken?.error === null) {
                return await actualizarConsentimiento(idAcuerdoCliente, datos, idIntermediario, true);
            }
        }
        return {
            error: response.auditResponse,
            datos: null
        };
    }
};

export const obtenerDocumentosConsentimiento = async (retried = false) => {
    const response = await ConsentimientoProvider.obtenerDocumentosConsentimiento();
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            documento: response.entity.datos
        };
    } else {
        if (!retried && response.auditResponse.detalle?.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken();
            if (responseToken?.error === null) {
                return await obtenerDocumentosConsentimiento(true);
            }
        }
        return {
            error: response.auditResponse,
            documento: null
        };
    }
};
